/**
 * Created by Ella Ma on 05/07/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input } from '@angular/core';
import { DataEventType } from './data-visualizations.model';
import { TamDashboardTileType } from '../../../tam-dashboard/tam-dashboard.model';
import { BriefConfig } from '../../../../widgets/widgets.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { getSystemConfigState } from '../../../../redux/reducers/system-config-view.reducer';

@Component({
    selector: 'tam-data-visualizations',
    templateUrl: './data-visualizations.component.html',
    styleUrls: ['./data-visualizations.component.scss']
})
export class DataVisualizationsComponent implements OnInit {

    @Input() config: BriefConfig;
    @Input() active: number;

    isMapTileEnabled = false;

    visualizationType = TamDashboardTileType;
    constructor(
        private _storeQuerier: StoreQuerierService,
    ) { }

    ngOnInit() {
        this._init();
    }

    dblClickIcon(index) {
        this.config.feedbackSubject$.next({ type: DataEventType.dblClickIcon, payload: index });
    }

    selectChart(index) {
        this.config.feedbackSubject$.next({ type: DataEventType.clickIcon, payload: index });
    }

    private _init() {
        const systemConfig = this._storeQuerier.queryBySelector(getSystemConfigState);
        if (systemConfig && systemConfig.maptile) {
            this.isMapTileEnabled = systemConfig.maptile['enable'];
        }
    }
}
